import { render, staticRenderFns } from "./InspectionTemporary.vue?vue&type=template&id=1c263b2d&scoped=true&"
import script from "./InspectionTemporary.vue?vue&type=script&lang=js&"
export * from "./InspectionTemporary.vue?vue&type=script&lang=js&"
import style0 from "./InspectionTemporary.vue?vue&type=style&index=0&id=1c263b2d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c263b2d",
  null
  
)

export default component.exports